import React from 'react';
import Button from '../../ui/Button';

const ClientFormActions = ({ isEditing, handleCancelEdit }) => {
  return (
    <div className="p-4 sm:p-6 bg-gray-50/50 flex flex-col sm:flex-row items-stretch sm:items-center justify-end gap-3 rounded-b-2xl">
      {isEditing && (
        <Button type="button" variant="secondary" onClick={handleCancelEdit} className="px-6 w-full sm:w-auto">
          Отказ
        </Button>
      )}
      <Button type="submit" variant="primary" className="px-6 w-full sm:w-auto bg-[#11a311] hover:bg-[#0f8c0f]">
        {isEditing ? 'Запази промените' : 'Добави клиент'}
      </Button>
    </div>
  );
};

export default ClientFormActions;
